import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { LoginData } from '../interfaces/login-data';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { Usuario } from '../interfaces/usuario';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  loginData: LoginData = {
    email : '',
    password: ''
  };

  constructor( private readonly authService: AuthService,
               private readonly router: Router,
               private menuCtrl: MenuController) { }



  ngOnInit() {
  }


  ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }


  login() {
    this.authService
      .login(this.loginData)
      .then((res) => {
        this.router.navigate(['/home']);
      })
      .catch((e) => console.log(e.message));
  }


}
